import React from 'react';
import { IntlProvider, useIntl } from 'react-intl';
import { Provider, useSelector } from 'react-redux';

import { store } from 'config/store/configureStore';
import { getLastNotification } from 'modules/toast-notifications/selectors';
import useNotification from 'ui/base/Notification';
import { get } from 'utils/ObjectUtils';

import CustomButton from './CustomButton';

const Toast = () => {
  const intl = useIntl();
  const notification = useNotification();
  const toastNotification = useSelector(getLastNotification);

  /**
   * @param {string | import('../../modules/notifications/types').Translation} message
   */
  const translate = React.useCallback(message => {
    let translation = message;

    if (message) {
      if (typeof message === 'object') {
        translation = intl.formatMessage(message, get(message, 'values') ?? {});
      } else {
        translation = intl.formatMessage({ id: message, defaultMessage: message });
      }
    }

    return translation;
  }, [intl]);

  React.useEffect(() => {
    if (toastNotification) {
      const { type = 'warning', message, description = null, btn, ...props } = toastNotification;

      notification[type](
        {
          ...props,
          title: translate(message),
          description: translate(description),
          // We have to connect the button to the store because it's not a child of the original Provider
          // We need Redux store to get the userId in `useLocalUserPreferences` used by `useAnalytics`
          actions: btn ? <IntlProvider locale={intl.locale} messages={intl.messages}><Provider store={store}><CustomButton {...btn} /></Provider></IntlProvider> : undefined,
        },
        intl
      );
    }
  }, [intl, translate, toastNotification]);

  return null;
};

export default Toast;
